import { render, staticRenderFns } from "./DuplicaCampos.vue?vue&type=template&id=43a86ab4&scoped=true&"
import script from "./DuplicaCampos.vue?vue&type=script&lang=js&"
export * from "./DuplicaCampos.vue?vue&type=script&lang=js&"
import style0 from "./DuplicaCampos.vue?vue&type=style&index=0&id=43a86ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a86ab4",
  null
  
)

export default component.exports